import { SrInsightType } from '@plato/data/starrocks/types';
import type { GetManyCustomersFilters } from '../../../server/types/infer-trpc-types.ts';
import { CustomerSortBy, SortOrder } from '../../../server/types/list-view-types.ts';

export const customersExpansionPotentialFilter = {
    cityNames: [],
    zipCodes: [],
    salesRepIds: [],
    searchString: '',
    industryNames: [],
    insightTypes: [],
    statuses: [],
    companyIds: [],
    customerClasses: [],
    salesRegions: [],
    customerIds: [],
    sortingFilter: {
        field: CustomerSortBy.INSIGHTS_SUM_OPPORTUNITY,
        direction: SortOrder.DESC,
    },
} satisfies GetManyCustomersFilters;

export const customersRevenueDeclineFilter = {
    cityNames: [],
    zipCodes: [],
    salesRepIds: [],
    searchString: '',
    industryNames: [],
    // Only the category type is selected: `customerBaseQuery` widens it to cover
    // `GlobalChurnWarning` too, so one chip and one checked box stand for both.
    insightTypes: [SrInsightType.CHURN_WARNING],
    statuses: [],
    companyIds: [],
    customerClasses: [],
    salesRegions: [],
    customerIds: [],
    sortingFilter: {
        field: CustomerSortBy.INSIGHTS_SUM_RISK,
        direction: SortOrder.ASC,
    },
} satisfies GetManyCustomersFilters;
